import { alias } from '@ember/object/computed';
import Route from 'cio/routes/base';
import CrumbsService, { Crumb } from 'cio/services/crumbs';

export default class PersonalRoute extends Route {
  @alias('crumbs') crumbsService!: CrumbsService;

  settingsCrumb: Crumb | undefined = undefined;

  crumb() {
    return {
      name: 'Personal Settings',
      path: this.routeName,
    };
  }

  activate() {
    let { crumbs } = this.crumbsService;
    let settingsCrumb = crumbs.find((crumb) => crumb.path === 'settings');

    this.setProperties({ settingsCrumb });

    if (settingsCrumb) {
      crumbs.removeObject(settingsCrumb);
    }

    super.activate();
  }

  deactivate() {
    if (this.settingsCrumb) {
      this.crumbsService.append(this.settingsCrumb);
    }

    super.deactivate();
  }
}
